import { useMemo } from "react";
import mandatorUtils from "utils/mandators";
import { useAuthStore } from "stores/authStore";
import { useAllProducts } from "hooks/productHooks/useAllProducts";
import { findProductInTree } from "hooks/productHooks/utils/filterProductListByMandator";

export const useFilteredProjects = (
  projects: Array<{
    id: string;
    title: string;
    country?: string;
    mandator?: number;
  }>,
  requestParams: {
    orderCode: { seriesId: string | number };
    productName: string;
  },
) => {
  const currentUserTenant = useAuthStore.use.currentUser()?.tenant;
  const allProducts = useAllProducts();
  const searchedProduct = findProductInTree(
    allProducts,
    requestParams.orderCode.seriesId,
    requestParams.productName,
  );

  const { countryOfOrigin } = searchedProduct || {};

  const filteredProjects = useMemo(() => {
    if (!countryOfOrigin || !currentUserTenant || !projects) {
      return projects;
    }

    return mandatorUtils.filterProjectsByProductMandator(
      projects,
      countryOfOrigin,
      currentUserTenant,
    );
  }, [currentUserTenant, projects, countryOfOrigin]);

  return filteredProjects;
};
